import {
    faCheck,
    faPenToSquare,
    faXmark,
    faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardBody, CardHeader, UncontrolledTooltip } from "reactstrap";

import { IEmailRule, IModal } from "Pages/Tools/EmailRules/EmailRules";
import styles from "Pages/Tools/EmailRules/Components/Rule/Rule.module.css";

export default function Rule({
    rule,
    onSetModal,
    onSetSelectedRule,
}: {
    readonly rule: IEmailRule;
    readonly onSetModal: (modal: IModal) => void;
    readonly onSetSelectedRule: (rule: IEmailRule) => void;
}) {
    const handleClick = (modal: IModal) => {
        onSetModal(modal);
        onSetSelectedRule(rule);
    };

    const ruleNameAsValidCssSelector = rule.name.replace(/[^a-zA-Z0-9]/g, "");

    return (
        <Card className={styles.rule}>
            {/* Header with rule name */}
            <CardHeader className={styles.header}>
                <div className={styles.headerNameAndStatusRow}>
                    <h5>{rule.name}</h5>
                    <div className={styles.statusBox}>
                        {rule.enabled ? "Enabled" : "Disabled"}
                        {rule.enabled ? (
                            <FontAwesomeIcon
                                icon={faCheck}
                                className={styles.enabled}
                            />
                        ) : (
                            <FontAwesomeIcon
                                icon={faXmark}
                                className={styles.disabled}
                            />
                        )}
                    </div>
                </div>

                {/* Edit and delete buttons */}
                <div className={styles.headerRowTwo}>
                    <FontAwesomeIcon
                        id={`editBtn-${ruleNameAsValidCssSelector}`}
                        icon={faPenToSquare}
                        className={styles.editBtn}
                        onClick={() => handleClick("edit")}
                    />
                    <UncontrolledTooltip
                        placement="top"
                        target={`editBtn-${ruleNameAsValidCssSelector}`}
                    >
                        Edit
                    </UncontrolledTooltip>
                    <FontAwesomeIcon
                        id={`deleteBtn-${ruleNameAsValidCssSelector}`}
                        icon={faTrashCan}
                        className={styles.deleteBtn}
                        onClick={() => handleClick("delete")}
                    />
                    <UncontrolledTooltip
                        placement="top"
                        target={`deleteBtn-${ruleNameAsValidCssSelector}`}
                    >
                        Delete
                    </UncontrolledTooltip>
                </div>
            </CardHeader>

            {/* Body with rule details */}
            <CardBody className={styles.cardBody}>
                <div className={styles.anyActionsBox}>
                    <b>Email on any actions: </b>
                    <div className={styles.statusBox}>
                        {rule.email_on_any_actions ? "Enabled" : "Disabled"}
                        {rule.email_on_any_actions ? (
                            <FontAwesomeIcon
                                icon={faCheck}
                                className={styles.enabled}
                            />
                        ) : (
                            <FontAwesomeIcon
                                icon={faXmark}
                                className={styles.disabled}
                            />
                        )}
                    </div>
                </div>

                <b>Integrations: </b>
                <ul>
                    {rule.integrations
                        .split(",")
                        .filter((i) => i !== "")
                        .map((i) => (
                            <li key={i}>
                                {i === "%" ? "All integrations" : i}
                            </li>
                        ))}
                </ul>

                <b>Trigger: </b>
                <ul>
                    <li>{rule.threshhold}</li>
                </ul>

                <b>Users: </b>
                <ul>
                    {rule.users
                        .split(",")
                        .filter((i) => i !== "")
                        .map((u) => (
                            <li key={u}>{u.trim()}</li>
                        ))}
                </ul>

                <b>CC'd Users: </b>
                <ul>
                    {rule.cc_users
                        .split(",")
                        .filter((i) => i !== "")
                        .map((u) => (
                            <li key={u}>{u}</li>
                        ))}
                </ul>
            </CardBody>
        </Card>
    );
}
